export default "__VITE_ASSET__BMm0jnJo__"